export default [
	{
		code: 'Proposal',
		color: 'orange',
	},
	{
		code: 'Active',
		color: '#379A2F',
	},
	{
		code: 'In Negotiation',
		color: '#9B3199',
	},
	{
		code: 'Under Contract',
		color: '#FFEF65',
	},
	{
		code: 'Closed',
		color: '#999',
	},
	{
		code: 'Removed',
		color: 'red',
	},
	{
		code: 'Property Info',
		color: 'blue',
	},
	{
		code: 'Off Market',
		color: '',
	},
];
